import { FC } from 'react';
import { Container } from './Loading.styles';

interface LoadingProps {
	fullScreen?: boolean;
	text?: string;
}

const Loading: FC<LoadingProps> = ({ fullScreen, text }) => {
	return (
		<Container $fullScreen={fullScreen}>
			{text && (
				<div className='loaderText'>{text}</div>
			)}
			<div className='loader' />
		</Container>
	);
};

export default Loading;
